import { writable } from 'svelte/store';
let isOnTransition = false;
export const headerStore = writable({ theme: 'transparent', background: 'transparent' });
// page text must be the same key on i18n json object
export const pages = [
    { path: '/index', text: 'HOME', theme: 'black', background: 'gray' },
    { path: '/work', text: 'WORK', theme: 'purple', background: 'wellabe-light' },
    { path: '/about', text: 'ABOUT', theme: 'white', background: 'blue' },
];
let transitionTimeout;
export function setInitialHeaderColors(theme, background) {
    headerStore.set({ theme, background: 'transparent' });
    isOnTransition = true;
    // clear previous timeout in case user is quickly navigating between pages
    if (transitionTimeout) {
        clearTimeout(transitionTimeout);
    }
    transitionTimeout = setTimeout(() => {
        isOnTransition = false;
        headerStore.set({ theme, background });
    }, 400);
}
export function setHeaderColor(theme, background, path) {
    if (isOnTransition) {
        return;
    }
    const { pathname } = window.location;
    if (pathname === '/' && (path === '/index' || path === '/')) {
        headerStore.set({ theme, background });
        return;
    }
    if (isOnTransition && path !== pathname) {
        return;
    }
    headerStore.set({ theme, background });
}
export function findCurrentPage() {
    const { pathname } = window.location;
    return pages.find((item) => {
        return item.path === pathname;
    });
}
export function checkInitialHeaderColors(ignoreScroll = false) {
    if (scrollY > 0 && !ignoreScroll) {
        return;
    }
    const currentPage = findCurrentPage();
    if (currentPage) {
        setInitialHeaderColors(currentPage.theme, currentPage.background);
        return;
    }
    setInitialHeaderColors('black', 'gray');
}
